class CollectionLoadMore extends HTMLElement {
  connectedCallback() {
    this.paginationType = this.getAttribute('data-pagination-type');
    this.nextUrl = this.getAttribute('data-next-url');
    this.isLoading = false;

    if (!this.nextUrl) return;

    if (this.paginationType === 'load_more') {
      this.button = this.querySelector('button');
      if (this.button) {
        this.button.addEventListener('click', this.loadNextPage.bind(this));
      }
    } else if (this.paginationType === 'infinite_scroll') {
      this.initInfiniteScroll();
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  initInfiniteScroll() {
    const options = {
      root: null, // Use the viewport
      rootMargin: '0px 0px 400px 0px', // Trigger load 400px before the element enters the viewport
      threshold: 0.0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.isLoading) {
          this.loadNextPage();
        }
      });
    }, options);

    const trigger = this.querySelector('#InfiniteScrollTrigger');
    if (trigger) {
      this.observer.observe(trigger);
    }
  }

  async loadNextPage() {
    if (this.isLoading || !this.nextUrl) return;
    this.isLoading = true;

    // Show loading state
    if (this.paginationType === 'load_more' && this.button) {
      this.button.classList.add('loading');
      const spinner = this.button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      const trigger = this.querySelector('#InfiniteScrollTrigger');
      if (trigger) {
        const spinner = trigger.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
      }
    }

    try {
      const response = await fetch(this.nextUrl);
      if (!response.ok) throw new Error('Network response was not ok');
      const htmlText = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');

      // Get the product-grid elements
      const newGrid = doc.getElementById('product-grid');
      const currentGrid = document.getElementById('product-grid');

      if (newGrid && currentGrid) {
        const newProducts = Array.from(newGrid.querySelectorAll('li.grid__item'));
        
        // We use a temporary container to initialize scroll reveal animations
        // before attaching them to the document. This prevents existing products 
        // from re-animating.
        const tempContainer = document.createElement('div');
        newProducts.forEach((product) => tempContainer.appendChild(product));

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(tempContainer);
        }

        // Append the new elements to the current product grid
        const targetContainer = currentGrid.tagName === 'UL' ? currentGrid : (currentGrid.querySelector('.product-grid') || currentGrid);
        while (tempContainer.firstChild) {
          targetContainer.appendChild(tempContainer.firstChild);
        }
      }

      // Update URL to match current page (replaces search state to prevent back navigation pollution)
      // history.replaceState(history.state, '', this.nextUrl);

      // Extract new pagination/load more component
      const newLoadMore = doc.querySelector('collection-load-more');
      const currentLoadMoreContainer = this.parentElement;

      if (newLoadMore && currentLoadMoreContainer) {
        this.replaceWith(newLoadMore);
      } else {
        // No more products, remove the load more component
        this.remove();
      }
    } catch (error) {
      console.error('Failed to load more products:', error);
    } finally {
      this.isLoading = false;
    }
  }
}

if (!customElements.get('collection-load-more')) {
  customElements.define('collection-load-more', CollectionLoadMore);
}
